import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';

import Container from '../../Core/Container';

import { StepControls, StepButton, Wrapper } from './styles';

export const Step = ({
  currentStep = 1,
  step = 1,
  component = false,
  children = null,
}) => {
  if (currentStep !== step) return null;
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{component ? React.createElement(component) : children}</>;
};

const Stepper = ({
  children,
  start = 0,
  className = '',
  showStepper = true,
}) => {
  const [state, setState] = useState({
    currentStep: start,
  });
  const intl = useIntl();

  useEffect(() => {
    goToStep(start);
  }, [start]);

  const goToStep = step => {
    setState(prevState => {
      const newState = { currentStep: step };
      return { ...prevState, ...newState };
    });
  };

  const Steps = React.Children.map(children, (child, index) => {
    const { currentStep } = state;
    return React.cloneElement(child, {
      currentStep,
      step: index,
    });
  });

  return (
    <>
      {showStepper && (
        <Container className={className}>
          <Wrapper className={className}>
            <StepControls>
              {Steps.map((el, index) => {
                return (
                  <StepButton
                    key={el.id}
                    onClick={() => goToStep(index)}
                    className={state.currentStep === index ? 'active' : ''}
                  >
                    {el.props.image && <img src={el.props.image} alt="" />}
                    {el.props.title
                      ? el.props.title
                      : `${intl.formatMessage({ id: 'stepLabel' })}` +
                        ' ' +
                        `${index + 1}`}
                  </StepButton>
                );
              })}
            </StepControls>
          </Wrapper>
        </Container>
      )}
      {Steps}
    </>
  );
};

Stepper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  start: PropTypes.number,
  className: PropTypes.string,
  showStepper: PropTypes.bool,
};

Step.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
    PropTypes.bool,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  currentStep: PropTypes.number,
  step: PropTypes.number,
};

export default Stepper;
